import * as queryString from 'querystring';

export function changeQueryString(
    searchString: string,
    documentTitle: string = document.title
): void {
    const splittedUrl = window.location.href.split('?');
    const newState = {
        title: documentTitle,
        url: splittedUrl[0] + (searchString ? '?' + searchString : '')
    };
    history.pushState(newState, newState.title, newState.url);
}

export function getErrorMessageFromQueryString(): string {
    const search = window.location.search
        ? window.location.search.indexOf('?') === 0
            ? window.location.search.slice(1)
            : window.location.search
        : '';

    return search ? (queryString.parse(search).errorMessage as string) : '';
}
